import "./style.css";
import logoSymbol from "../../assets/images/logoSymbol.png";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import profileImage from "../../assets/images/profileImage.png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import withUser from "../../redux/HOC/withUser";
import Avatar from "@mui/material/Avatar";
import { TimeoutLogic } from "./TimeLogic";
import { SignOutApi } from "../../utils/API";
import { BroadcastChannel } from "broadcast-channel";
import { useEffect, useState } from "react";
import { navMenuItems, pageConstant } from "../../config/pageConstant";
import _ from "lodash";
import { hasAccess } from "../../common/commonFunctions";
import { Icon } from "@iconify/react";
import React from "react";
import { SwipeableDrawer } from "@mui/material";
import VerticalNavigation from "./verticalNav";
import ClientAccountSelector from "./clientAccountSelector";
import { consoleClearTime } from "../../common/constants";
import { envs, getEnv } from "../../config/service-api-mapping";

const Header = ({ user, setUser }: any) => {
  const navigate = useNavigate();
  const logoutChannel = new BroadcastChannel("logout-channel");
  const { ticker_in } = useParams();
  const onClickNavigate = (page: string) => {
    navigate(`${page}`);
  };
  const handleClickNewTab = (url: string) => {
    const path = window.location.href;
    const myArray = path.split("#");
    const openWindow = myArray[0] + "#" + url;
    window.open(openWindow, "", "fullscreen=yes,location=0");
  };

  const onLogout = async () => {
    logoutChannel.postMessage("logout");
    await SignOutApi();
    window.localStorage.clear();
    window.sessionStorage.clear();
    navigate("/signin");
  };

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    if (string && string.length) {
      for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
      }
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        maginLef: "20px",
        marginTop: "-4px",
        marginLeft: "-6px",
        width: "30px",
        height: "30px",
        fontSize: "small",
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const appLogo = () => {
    return (
      <>
        {/* <div className="navbar-brand logoImage mt-3 mb-0"> */}
        <img
          src={logoSymbol}
          onClick={() => onClickNavigate("/dashboards/sl-quote/MSFT")}
          style={{ width: "1.5rem", height: "1.5rem" }}
          alt="Logo"
          className="ms-4 mb-0"
        />
        {/* </div> */}
      </>
    );
  };
  const [isSmallerDevice, setISSmallerDevice] = useState(
    window?.innerWidth <= 912
  );

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      if (window?.innerWidth <= 912) {
        setIsDrawerOpen(false);
        setISSmallerDevice(true);
      } else {
        setISSmallerDevice(false);
      }
    }

    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userProfile = () => {
    return (
      <div className="appBar">
        <div className="">
          <div
            className={
              isSmallerDevice ? "dropdown" : "collapse navbar-collapse dropdown"
            }
            id="user-profile"
          >
            <div
              className="userBarIcon dropdown-toggle p-1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {user.fullName == null ? (
                <img
                  src={profileImage}
                  className="profileImage"
                  alt="Profile Img"
                />
              ) : (
                <Avatar {...stringAvatar(user.fullName.toUpperCase())} />
              )}
            </div>
            <ul className="dropdown-menu dropdown-menu-end py-0 mt-2">
              <li key={"fullname"} className="d-flex justify-content-start">
                <span className="dropdown-item drp-item dropdownMenuItem ps-2">
                  <Icon icon="flowbite:user-solid" fontSize="1.3rem" />{" "}
                  {user.fullName}
                </span>
              </li>
              <li key={"change-pwd"} className="d-flex justify-content-start">
                <span
                  className="dropdown-item drp-item dropdownMenuItem ps-2"
                  onClick={() => onClickNavigate("change-password")}
                >
                  <Icon
                    fontSize="1.2rem"
                    icon={"gg:profile"}
                    className="me-1"
                  />{" "}
                  User Profile
                </span>
              </li>
              <li key={"log-out"} className="d-flex justify-content-start">
                <span
                  className="dropdown-item drp-item dropdownMenuItem ps-2"
                  onClick={onLogout}
                >
                  <Icon fontSize="1.3rem" icon={"hugeicons:logout-05"} /> Logout
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const returnInterval = setInterval(() => {
      if (
        getEnv() === envs.DEV ||
        getEnv() === envs.QA ||
        getEnv() === envs.AWS_DEV
      )
        console.clear();
    }, consoleClearTime);
    return () => clearInterval(returnInterval);
  }, []);

  const location = useLocation();

  const isParentActive = (parentPath: any) => {
    return location.pathname === parentPath || location.pathname.startsWith(parentPath + "/");
  };

  return (
    <>
      <TimeoutLogic />
      {isSmallerDevice && (
        <React.Fragment>
          <SwipeableDrawer
            open={isDrawerOpen}
            onClose={toggleDrawer}
            onOpen={toggleDrawer}
            anchor="left"
            sx={{width:'35%'}}
          >
            <div>
              {isDrawerOpen && (
                <VerticalNavigation
                  closeVerticalNav={closeDrawer}
                ></VerticalNavigation>
              )}
            </div>
          </SwipeableDrawer>
        </React.Fragment>
      )}
      <div className="d-flex flex-row">
        <nav className="navbar navbar-expand-sm headerMainDiv d-flex align-items-center justify-content-between">
          {isSmallerDevice && (
            <>
              <div className="d-flex flex-row justify-content-between w-100">
                <button
                  className="v-nav-toggler justify-content-start"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarText"
                  aria-controls="navbarText"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  onClick={toggleDrawer}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="d-flex justify-content-end logoImage align-items-center"
                  aria-label="Toggle navigation"
                >
                  {userProfile()}
                </div>
              </div>
            </>
          )}
          {!isSmallerDevice && (
            <>
              <div className="d-flex justify-content-start align-items-center">
                {appLogo()}
                <header className="nav-header">
                  <nav className="navbar">
                    <ul className="menu">
                      {navMenuItems?.map((menu: any) => {
                        return (
                          <>
                            {hasAccess(menu?.permissions) && (
                              <>
                                <li className="dropdown-item">
                                  <NavLink
                                    onClick={(e) => e.preventDefault()}
                                    to={``}
                                    className={({ isActive }) =>
                                      isParentActive(menu?.link) ? "main-active-link" : ""
                                    }
                                  >
                                    {menu?.label}
                                  </NavLink>

                                  <ul className="submenu">
                                    {menu?.submenu?.map((subMenu: any) => {
                                      return (
                                        <>
                                          {(subMenu.link ==='/locates-client' ?!hasAccess([`${pageConstant.LOCATE_DASHBOARD}_ADMIN`,`${pageConstant.LOCATE_DASHBOARD}_RW`, `${pageConstant.LOCATE_DASHBOARD}_RO`]) && hasAccess(subMenu?.permissions):(hasAccess(subMenu?.permissions))) && (
                                            <>
                                              <li>
                                                <NavLink
                                                  to={`${subMenu.link === '/sl-quote'?(`/dashboards/sl-quote/${(ticker_in && !_.isEmpty(ticker_in) && ticker_in?.length > 0)? ticker_in: "MSFT"}`):`${menu.link}${subMenu.link}`}`}
                                                  className={({ isActive }) =>
                                                    isActive
                                                      ? "active-link"
                                                      : ""
                                                  }
                                                >
                                                  {subMenu?.label}
                                                  <OpenInNewIcon
                                                    className="ms-1"
                                                    onClick={(e: any) => {
                                                      e?.preventDefault();
                                                      handleClickNewTab(
                                                        `${subMenu.link === '/sl-quote'?(`/dashboards/sl-quote/${(ticker_in && !_.isEmpty(ticker_in) && ticker_in?.length > 0)? ticker_in: "MSFT"}`):`${menu.link}${subMenu.link}`}`
                                                      );
                                                    }}
                                                    style={{ fontSize: "0.8rem" }}
                                                  />
                                                </NavLink>
                                              </li>
                                            </>
                                          )}
                                        </>
                                      );
                                    })}
                                  </ul>
                                </li>
                              </>
                            )}
                          </>
                        );
                      })}
                    </ul>
                  </nav>
                </header>
              </div>
              <div className="profileBar-logoName d-flex justify-content-end me-3">
                <ClientAccountSelector
                  isHorizontalNav={true}
                ></ClientAccountSelector>
                {userProfile()}
              </div>
            </>
          )}
        </nav>
      </div>
    </>
  );
};
export default withUser(Header);
